<template>
	<div id="app">
		<router-view></router-view>
		<Footer />
	</div>
</template>

<script>
	import Footer from './common/Footer'
	export default {
		name: 'app',
		components: {
			Footer
		},
		data() {
			return {
				status: 0
			};
		},
		created() {
			this.getBaseInfo();
			// this.initLanguage()
		},
		methods: {
			initLanguage() {
				// 获取浏览器语言并转为小写，方便匹配
				let lang = (navigator.language || navigator.userLanguage).toLowerCase();
				console.log(lang, 'lang');
				localStorage.setItem('lang', lang);
				this._i18n.locale = lang;
			},
			getBaseInfo() {
				this.$http({
					method: 'get',
					url: 'base_info'
				}).then(res => {
					localStorage.setItem('kf', res.data.kefu[0].value)
					localStorage.setItem('kfName', res.data.kefu[0].name)
					localStorage.setItem('kefu', res.data.kefu)
					localStorage.setItem('logo', res.data.logo)
					localStorage.setItem('lang', res.data.defaultLang);
					this._i18n.locale = res.data.defaultLang;
					console.log(res.data, '5555')
					//this.$store.commit('setBaseInfoValue', res.data);
				})
			}
		}

	}
</script>

<style>
	/* 当屏幕宽度大于 750px 时（即 PC 端） */
	/* @media screen and (min-width: 512px) {
		#app {
			width: 750px !important;
			transform: scale(calc(750 / 100vw));
			transform-origin: top center;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
		}

		.van-tabbar--fixed {
			max-width: 750px !important;
			left: 50% !important;
			transform: translateX(-50%) !important;
		}

		.id {
			max-width: 750px !important;
			left: 50% !important;
			transform: translateX(-50%) !important;
		}
	} */

	/* App.vue */
	#app {
		max-width: 750px !important;
		margin: 0 auto !important;
		position: relative !important;
		background-color: #fff !important;
	}

	/* 如果你想让 PC 端网页背景是灰色的，而 H5 区域是白色的 */
	body {
		background-color: #f5f5f5;
		margin: 0;
	}

	body .van-toast {
		font-size: 30px;
		padding: 30px;
		line-height: 50px;
		width: 230px;
		background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;
	}

	body .van-toast .van-toast__icon {
		font-size: 50px;
	}

	*,
	:after,
	:before {
		box-sizing: border-box;
	}
</style>